import type { YoutubeVideoData } from '@/api/ai/youtube/types';
import { YoutubeInfo, YoutubePlayer } from './components';
export interface YoutubePreviewCardProps {
  videoData: YoutubeVideoData;
}

/**
 * YouTube 영상 미리보기 카드 컴포넌트
 */
export const YoutubePreviewCard = ({
  videoData
}: YoutubePreviewCardProps) => {
  return <div className="flex h-full w-full flex-col gap-xs" data-sentry-component="YoutubePreviewCard" data-sentry-source-file="YoutubePreviewCard.tsx">
      {/* 썸네일 또는 플레이어 영역 (AC-2.3.2, AC-2.3.3) */}
      <YoutubePlayer videoData={videoData} data-sentry-element="YoutubePlayer" data-sentry-source-file="YoutubePreviewCard.tsx" />
      <YoutubeInfo videoData={videoData} data-sentry-element="YoutubeInfo" data-sentry-source-file="YoutubePreviewCard.tsx" />
    </div>;
};